import React from "react";
const WelcomePage = () => {
  return (
    <div className="h-screen w-full flex relative overflow-hidden font-iranSansNormal">
      <div className="relative z-10 p-4  ">
        <p className="pt-5 text-gray-800 text-4xl font-iranSansNormal">
          سلام خوش آمدید
        </p>
        <p className="text-gray-700 text-[24px] pt-[20px]">
          در صورت بروز هرگونه مشکل در سامانه، به مدیریت اطلاع دهید.
        </p>
      </div>
    </div>
  );
};

export default WelcomePage;
